import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Divider, Header, Icon } from 'semantic-ui-react';

const ActionDialogItems = ({
  action = 'delete',
  children,
  entities,
  icon,
}) => (
  <>
    <Divider horizontal>
      <Header as="h4">
        <Icon name={icon} />
        <FormattedMessage id={`${entities}.${action}.divider`} />
      </Header>
    </Divider>
    {children}
  </>
);

export default ActionDialogItems;
